import { Component, OnInit, DoCheck } from '@angular/core';
import {MatDialog } from '@angular/material';
import { HttpClient } from '@angular/common/http';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from 'environments/environment';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';

import {MatSnackBar} from '@angular/material';


export interface PeriodicElement {
  id: string;
  cuit: string;
  empresa: string;
  fecha: string;
  importe: number;
  periodo: string;
  obs: string;
  contacto: string;
  responsable: string;
  estado: string;
}
const ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-sinomyt',
  templateUrl: './sinomyt.component.html',
  styleUrls: ['./sinomyt.component.css']
})

export class SinomytComponent implements OnInit, DoCheck {
  option;
  filtroCUIT;
  filtropdesde;
  filtrophasta;
  filtrofrecdes;
  filtrofrechas;
  // tslint:disable-next-line: no-inferrable-types
  modaless: string = 'modal-body';
  loading;
  loadingins;
  // tslint:disable-next-line: max-line-length
  displayedColumns: string[] = ['select', 'CUIT', 'RAZON_SOCIAL', 'DESDE', 'HASTA', 'REMOSIMP', 'DDJJ_APORTE', 'DDJJ_CONTRIB','DEUDA_NOM', 'Transf_C', 'Transf_D', 'Transferido', 'SALDO'];
  dataSourceOpe ;
  dataSourceOpeTotal;
  selection = new SelectionModel<PeriodicElement>(true, []);
  fecha_hoy;
  fechad;
  fechah;

  pcuit; pfecha; pimporte; pperiodo; pobs; pestado;

  item = [{}];
  modifobs;
  modifestado;
  // tslint:disable-next-line: no-inferrable-types
  modalessHeader: string = 'modal-header';
  modalessBody;
  apagar = true;

  constructor(
    private http: HttpClient,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    public snackBar: MatSnackBar ) {
      this.loading = false;
      this.loadingins = false;
      this.fecha_hoy = new Date;
      this.fecha_hoy = this.datePipe.transform(this.fecha_hoy, 'yyyy-MM-dd');
      this.filtropdesde = '20/07';
      this.filtrophasta = '20/07';
      this.filtrofrecdes = '2020-01-01';
      this.filtrofrechas = '2020-01-31';
      this.pfecha = this.fecha_hoy;
      this.option = 'GENERAL';
  }

  ngOnInit() {
    console.log(this.fecha_hoy);
  }

  // tslint:disable-next-line: member-ordering
  obse = false;
  habilitaobs() {
    if (this.obse === false) {
      this.obse = true;
    } else {
      this.obse = false;
    }
  }

  // tslint:disable-next-line: member-ordering
  status = false;
  habilitaestado() {
    if (this.status === false) {
      this.status = true;
    } else {
      this.status = false;
    }
  }

  // tslint:disable-next-line: member-ordering
  fecrec;
  ngDoCheck() {
    // tslint:disable-next-line: radix
    this.fecrec = `20${(this.filtropdesde).slice(0, 2)}-${(parseInt(this.filtropdesde.slice(3, 5)) + 1)}-01`;
    // console.log(this.fecrec);
  }

  clean() {
    this.selection.clear();
  }
  exportExcel(data: any[]) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    // tslint:disable-next-line: max-line-length
    XLSX.writeFile(workbook, `ReporteSinomyt_desde_${this.filtropdesde}_hasta_${this.filtrophasta}_generado_${this.fecha_hoy}.xls`, { bookType: 'xls', type: 'buffer' });
 }

 exportExcel2(data: any[]) {
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
  // tslint:disable-next-line: max-line-length
  XLSX.writeFile(workbook, `ReporteSinomyt_FECHA_REC_DES_${this.filtrofrecdes}_HASTA_${this.filtrofrechas}_GENERADO_EL_${this.fecha_hoy}.xls`, { bookType: 'xls', type: 'buffer' });
}

  exportAsExcelReporte() {
    console.log('Generando reporte..');
    this.exportExcel(this.dataSourceOpe);
  }

  // tslint:disable-next-line: member-ordering
  loading2 = false;
  // tslint:disable-next-line: member-ordering
  loading3 = false;
  generarFecrecBeneficiario() {
    this.loading3 = true;
    this.apagar = true;
      this.dataSourceOpeFecrec =  null;
      // desgloza por fecha recaudacion empleado x empledado de tabla
      // http://localhost:1337/api/sinomyt/get_empleados?frecd=2020-05-01&frech=2020-05-15
      this.http.get(`${environment.backendUrl}/api/sinomyt/get_empleados?frecd=${this.filtrofrecdes}&frech=${this.filtrofrechas}`)
      .subscribe((datos: any[]) => {
        if (datos) {
          this.dataSourceOpeFecrec = datos;
          // console.log(this.dataSourceOpeFecrec);
          this.apagar = false;
          console.log('Generando reporte de empleados..');
          this.exportExcel2(this.dataSourceOpeFecrec);
          this.loading3 = false;
        } else {
          console.warn('NO HAY');
          this.loading3 = false;
        }
      });
  }
  generarFecrec() {
    this.loading2 = true;
    this.apagar = true;
      this.dataSourceOpeFecrec =  null;
      // http://localhost:1337/api/sinomyt/getFECREC?fdes=2020-04-01&fhas=2020-04-30  -- si quiere buscar por fecrecaudacion
      this.http.get(`${environment.backendUrl}/api/sinomyt/getFECREC?fdes=${this.filtrofrecdes}&fhas=${this.filtrofrechas}`)
      .subscribe((datos: any[]) => {
        if (datos) {
          this.dataSourceOpeFecrec = datos;
          // console.log(this.dataSourceOpeFecrec);
          this.apagar = false;
          console.log('Generando reporte de agentes de retencion..');
          this.exportExcel2(this.dataSourceOpeFecrec);
          this.loading2 = false;
        } else {
          console.warn('NO HAY');
          this.loading2 = false;
        }

      });
  }

  // tslint:disable-next-line: member-ordering
  dataSourceOpeFecrec;
  cargarGrid() {
    this.dataSourceOpe =  null;
    if (this.option === 'GENERAL') {
      console.log('por GENERAL');
      // http://localhost:1337/api/sinomyt/get?perdes=20/03&perhas=20/03 -- por periodo repo gral
      this.loading = true;
      this.apagar = true;
      this.http.get(`${environment.backendUrl}/api/sinomyt/get?perdes=${this.filtropdesde}&perhas=${this.filtrophasta}`)
      .subscribe((datos: any[]) => {
        if (datos) {

          this.dataSourceOpe = datos;
          let nom = 0;
          let transf = 0;
          let saldo = 0;

          datos.forEach (function(numero) {
            nom += numero['DEUDA_NOM'];
            transf += numero['Transferido'];
            saldo += numero['SALDO'];
          });
          // tslint:disable-next-line: max-line-length
          this.dataSourceOpeTotal = [{ CUIT: '------', RAZON_SOCIAL: 'TOTALES:', DESDE: this.dataSourceOpe[0]['DESDE'], HASTA: this.dataSourceOpe[0]['HASTA'], REMOSIMP: '', DDJJ_APORTE: '', DDJJ_CONTRIB: '', DEUDA_NOM: nom, Transf_C: '', Transf_D: '', Transferido: transf, SALDO: saldo }];
          // console.log('dataSourceOpeTotal', this.dataSourceOpeTotal);
          // console.log('dsope', this.dataSourceOpe);
          this.apagar = false;
        } else {
          console.warn('NO HAY');
        }
        this.loading = false;
      });
    }
    if (this.option === 'EMPRESA') {
      // console.log("POR EMPRESA");
      // http://localhost:1337/api/sinomyt/get_cui?perdes=20/01&perhas=20/03&cui=30-70942849-3  --  por EMPRESA y perides/has
      this.loading = true;
      this.apagar = true;
      // tslint:disable-next-line: max-line-length
      this.http.get(`${environment.backendUrl}/api/sinomyt/get_cui?perdes=${this.filtropdesde}&perhas=${this.filtrophasta}&cui=${this.filtroCUIT}`)
      .subscribe((datos: any[]) => {
        if (datos) {
          this.dataSourceOpe = datos;
          // console.log(this.dataSourceOpe);
          this.apagar = false;
        } else {
          console.warn('NO HAY');
        }
        this.loading = false;
      });
    }

  }

   /** Whether the number of selected elements matches the total number of rows. */
   isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceOpe.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSourceOpe.forEach(row => this.selection.select(row));
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: PeriodicElement): string {
    this.clean();
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }


}
